import React, { useState } from "react";

/**
 * ปุ่มไอคอนกลมสำหรับคอลัมน์ "จัดการ" ในตารางทุกเมนู (ดู / แก้ไข / ลบ ฯลฯ)
 * ขนาดและหน้าตาเดียวกันทั้งระบบ พร้อม tooltip ชื่อปุ่มตอน hover
 *
 * ใช้:
 *   <ActionIconButton label={t("view")}   icon={ACTION_ICONS.view}   variant="primary" onClick={() => ...} />
 *   <ActionIconButton label={t("edit")}   icon={ACTION_ICONS.edit}   variant="warning" onClick={() => ...} />
 *   <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger"  onClick={() => ...} />
 *
 * ครอบกลุ่มปุ่มด้วย <div className="d-flex align-items-center gap-2 justify-content-center">
 */

// สไตล์ปักคอลัมน์ action ไว้ขวาสุด (sticky) ใช้กับ <th>/<td> ที่ใส่ className bg-white ด้วย
export const STICKY_ACTION_STYLE = {
  position: "sticky",
  right: 0,
  zIndex: 2,
  boxShadow: "-6px 0 6px -6px rgba(0,0,0,0.15)",
};

// ไอคอนมาตรฐาน (Font Awesome glyph) ใช้ชุดเดียวกันทุกหน้า
export const ACTION_ICONS = {
  view: "",
  edit: "",
  delete: "",
  check: "",
  close: "",
  play: "",
  print: "",
  download: "",
  phone: "",
  key: "",
  copy: "",
};

// สีมาตรฐานตามชนิดปุ่ม: ดู=primary แก้ไข=warning ลบ=danger
export const ACTION_VARIANTS = {
  view: "primary",
  edit: "warning",
  delete: "danger",
};

const BUTTON_SIZE = { width: "26px", height: "26px", fontSize: "12px" };

export default function ActionIconButton({ label, icon, variant = "primary", onClick, className = "", style, disabled = false }) {
  const [hover, setHover] = useState(false);

  return (
    <div className="position-relative d-inline-flex" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <button
        type="button"
        className={`btn btn-outline-${variant} rounded-circle d-inline-flex align-items-center justify-content-center p-0 ${className}`}
        style={{ ...BUTTON_SIZE, ...style }}
        aria-label={label}
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) onClick(e);
        }}
      >
        <span className="icon">{icon}</span>
      </button>
      {hover && label && (
        <span
          className="position-absolute start-50 translate-middle-x px-2 py-1 rounded-3 text-white text-10 fw-bold shadow-sm"
          style={{
            bottom: "calc(100% + 8px)",
            backgroundColor: "#111827",
            whiteSpace: "nowrap",
            zIndex: 20,
            letterSpacing: "0.02em",
            pointerEvents: "none",
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
}
